module.exports = __webpack_public_path__ + "img/technology-15.63a0d7a5.png";